import { FadeIn } from './FadeIn';
import { BalanceSpring } from '@/components/Animation/BalanceSpring';
import { BlurText } from '@/components/Animation/BlurText';

export const Animation = {
  FadeIn,
  BalanceSpring,
  BlurText,
};
